import TemplateView from "../../../../TemplateView"
import CheckboxIcon from '../../../../components/CheckboxIcon'

export default class AssignAllMenuButton extends TemplateView {
    constructor({
        onClick = () => {},
        additionalClass = '',
    }) {
        super()

        this.onClick = onClick
        this.additionalClass = additionalClass

        this.state = {
            checked: false,
            indeterminate: false,
            disabled: false
        }

        this.onAnyStatePropertyChanged(['checked', 'indeterminate'], ({checked, indeterminate}) => this.checkbox.setState({
            checked: checked,
            indeterminate: !checked && indeterminate,
        }))
        this.onStatePropertyChanged('disabled', disabled => this.$el.toggleClass('disabled', disabled))
    }

    templateHtml() {
        return "<div class='assignAllMenuButton <%=additionalClass%>'>" +
               "  <div class='checkboxPlaceholder'></div>" +
               "  <div class='icon'></div>" +
               "</div>"
    }

    afterRender() {
        this.checkbox = new CheckboxIcon().init(this.find('.checkboxPlaceholder'))

        this.$el.click(() => {
            if (!this.state.disabled) {
                this.onClick()
            }
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/hierarchyAssignmentsEditor/AssignAllMenuButton.js